import styled from 'styled-components'
import theme from '../../theme/theme';

export const EventWithIcon = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap; /* Prevent line breaks */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Show ellipsis for overflow */
`;

export const EventIcon = styled.img`
  width: auto;
  height: 20px;
  margin-left: 5px;
  margin-right: 5px;

    @media (max-width: 600px) {
        margin: 0 auto;
    }
`;

export const EventTitle = styled.span`
  font-family:'Inter', sans-serif;
  font-size: 14px; /* Change the font size as desired */
  color: #333; /* Change the text color as desired */
  padding: 5px;

  @media (max-width: 600px) {
    display: none;
    padding: 0;
  }
`;

export const EventSubtitle = styled.span`
  font-family:'Inter', sans-serif;
  font-size: 10px;
  color: ${theme.color.stone};
  margin: -10px 0 5px 8px;

  @media (max-width: 600px) {
    display: none;
    padding: 0;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
